import React from "react";
import MuiBox from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import Typography from "@material-ui/core/Typography";
import DescriptionIcon from "@material-ui/icons/Description";
import styled from "@material-ui/core/styles/styled";
import PDFViewer from "../pdfViwer/PDFViewer";
import pxToRem from "libs/pxToRem";

interface IDocumentViewer {
  documentUrl: string;
  loading?: boolean;
  hasDocument?: boolean;
  emptyMessage?: string;
  emptyTitle?: string;
}

const DocumentViewer = React.memo(({
  documentUrl,
  loading,
  hasDocument = true,
  emptyMessage = "No hay un documento asociado a esta solicitud.",
  emptyTitle = "Documento no disponible"
}: IDocumentViewer) => {
  const isPdf = documentUrl?.includes(".pdf");

  if (loading) {
    return (
      <DocumentViewerContainer>
        <LoadingContainer>
          <CircularProgress size={60} />
        </LoadingContainer>
      </DocumentViewerContainer>
    );
  }

  if (!hasDocument || !documentUrl) {
    return (
      <DocumentViewerContainer>
        <NoDocumentContainer>
          <DescriptionIcon style={{ fontSize: 80, color: "#9e9e9e" }} />
          <NoDocumentTitle>{emptyTitle}</NoDocumentTitle>
          <NoDocumentSubtitle>
            {emptyMessage}
          </NoDocumentSubtitle>
        </NoDocumentContainer>
      </DocumentViewerContainer>
    );
  }

  const handleOpenNewTab = () => {
    window.open(documentUrl, "_blank");
  };

  return (
    <DocumentViewerContainer>
      {isPdf ? <PDFViewer url={documentUrl} /> : <IMGViewer url={documentUrl} />}
      <FloatingButton
        onClick={handleOpenNewTab}
        aria-label="Abrir en nueva pestaña"
      >
        <OpenInNewIcon />
      </FloatingButton>
    </DocumentViewerContainer>
  );
});

interface IIMGViewer {
  url: string;
}

const IMGViewer = ({ url }: IIMGViewer) => {
  return (
    <img
      src={url}
      alt="documento"
      style={{ width: pxToRem(743), height: pxToRem(1052) }}
    />
  );
};

const DocumentViewerContainer = styled(MuiBox)({
  display: "flex",
  justifyContent: "center",
  textAlign: "center",
  position: "relative",
  minWidth: pxToRem(743),
  minHeight: pxToRem(400),
});

const LoadingContainer = styled(MuiBox)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: pxToRem(743),
  minHeight: pxToRem(600),
});

const FloatingButton = styled(IconButton)({
  position: "absolute",
  top: pxToRem(10),
  right: pxToRem(10),
  backgroundColor: "rgba(0, 0, 0, 0.6)",
  color: "#fff",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
  },
});

const NoDocumentContainer = styled(MuiBox)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: pxToRem(60),
  minHeight: pxToRem(400),
  width: pxToRem(743),
});

const NoDocumentTitle = styled(Typography)({
  fontSize: pxToRem(24),
  fontWeight: 600,
  color: "#424242",
  marginTop: pxToRem(20),
  marginBottom: pxToRem(10),
});

const NoDocumentSubtitle = styled(Typography)({
  fontSize: pxToRem(14),
  color: "#757575",
  textAlign: "center",
  maxWidth: pxToRem(400),
  lineHeight: 1.5,
});

export default DocumentViewer;
